<div class="cx-one-ui">
    <!-- header -->
    <div class="modal-header cxone-modal-header">
        <div cvLocalizedText langSection="CXOne_Modal" langKey="Thresholds">Thresholds</div>
        <div class="modal-close">
            <button type="button" class="icon-btn fill-iconDefault" (click)="cancel()">
                <svg class="icon-12"><use href="../../App_Themes/CXone/icons/close.svg#close"></use></svg>
            </button>
        </div>
    </div>
    <div class="modal-body cxone-modal-body cxms-loader-holder p-0 position-relative " *ngIf="isLoading">
        <cv-loader size="medium" [overlay]="false"></cv-loader>
    </div>

    <!-- body -->
    <div class="modal-body cxone-modal-body" [hidden]="isLoading">
        <div class="select-metrics-label">
            <label cvLocalizedText langSection="CXOne_Modal" langKey="Set_Threshold">Set Threshold</label>
            <cv-multi-select
                class="group-selector-body flex-fill d-flex flex-column"
                [options]="metrics"
                [value]="selectedMetrics"
                (valueChange)="onSelectionChanged($event)"
                primaryKey="Id" label="Name"
                (opened)="onSelectorOpened()"
                (closed)="onSelectorClosed()"
            ></cv-multi-select>
        </div>


        <div *ngIf="!selectedMetrics || selectedMetrics.length < 1" class="metrics-body empty-message">
            <svg class="empty-error-icon"><use href="../App_Themes/CXone/icons/empty.svg#empty"></use></svg>
            <span class="metric-text" cvLocalizedText langSection="CXOne_Modal" langKey="No_Metric_Message">No metrics selected yet</span>
        </div>
        <form #thresholdsForm="ngForm" class="metrics-body" [ngStyle]="{'height': selectedMetrics && selectedMetrics.length > 0 ? '100%' : '0px'}">
            <div *ngIf="selectedMetrics && selectedMetrics.length > 0">
                 <div class="metric-item" *ngFor="let metric of selectedMetrics; trackBy: trackByMetric">
                    <div class="item-header">
                        <div class="item-labels">
                            <div class="metric-name">{{metricNames.get(metric.toString())}}</div>
                            <div class="select-text" cvLocalizedText langSection="CXOne_Modal" langKey="Set_Values">Set the values for each range for the Metric</div>
                        </div>
                        <div>
                            <button type="button" class="delete-button btn btn-icon fill-iconDefault" (click)="deselectMetric(metric.toString())">
                                <svg class="icon-12"><use href="../App_Themes/CXone/icons/delete.svg#delete"></use></svg>
                            </button>
                        </div>
                    </div>

                    <cv-sol-range-slider-wrapper [min]="metricThresholdRangeMap?.[metric]?.min ?? 0"
                        [max]="metricThresholdRangeMap?.[metric]?.max ?? 100"
                        [metricConversionType]="getConversionType(metric)"
                        [thresholdData]="metricThresholds[metric]"
                        [metricDirection]="getDirection(metric)"
                        (rangesCreated)="onRangeDataCreated($event, metric)"
                        (rangesError)="onRangeError($event, metric)"
                        >
                    </cv-sol-range-slider-wrapper>
                    <span *ngIf="!metricThresholdRangeMap[metric].error" class="range-conflict"></span>
                    <span *ngIf="metricThresholdRangeMap[metric].error.isConflictOverrideError" class="range-conflict" cvLocalizedText langSection="CXOne_Modal" langKey="Ranges_Conflict">
                        Slider values overlap. Adjust to avoid conflict.
                    </span>
                </div>
            </div>
        </form>
    </div>

    <!-- footer -->
    <div class="modal-footer cxone-modal-footer">
        <button class="btn btn-secondary modal-footer-btn ml-auto" (click)="cancel()" cvLocalizedText langSection="CXOne_Modal" langKey="Cancel">
            Cancel
        </button>
        <button class="btn btn-primary modal-footer-btn ml-2" (click)="save()" cvLocalizedText langSection="Common" langKey="Apply" [disabled]="hasThresholdError">
            Apply
        </button>
    </div>
</div>